import React, { useEffect, useState, useRef, useLayoutEffect, useContext } from "react";
import ReactDatePicker from "react-datepicker";
import Multiselect from "multiselect-react-dropdown";
import Loader from "react-spinner-loader";
import "react-datepicker/dist/react-datepicker.css";
import "./DmsDashboardNew.css";
import { GridStack } from "gridstack";
import { useTranslation } from "react-i18next";
import {
  getChildRegionsById,
  getAllincidents,
  getTaskConfigsURL,
  getFloodEntityStats,
  getFacilityReport,
  getASStats,
  getFacilityOpenReport,
  facilityDashboardData,
  getThemeURL,
} from "../../../../Services/EndPoints";
import LMSButton from "../../Common/LMSButton/LMSButton";
import moment from "moment";
import FacilityTypeView from "./FacilityTypeView/FacilityTypeView";
import CommunityKitchenTrendView from "../CommunityKitchenTrendView";
import FloodReliefCampTrendView from "../FloodReliefCampTrendView";
import AnimalCenterTrendView from "../AnimalCenterTrendView";
import {
  postDataWithBodyFrGIS,
  postDataWithBody,
  getData,
} from "../../../../Services/Services";
import FacilityRegistered from "./FacilityRegistered/FacilityRegistered";
import OpenCloseChart from "./OpenCloseChart/OpenCloseChart";
import HealthCampChart from "./HealthCamp/HealthCampChart";
import {
  commmunityKitchen,
  floodRelifCamp,
  healthCamp,
} from "./DMSDashboardConfig";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Popover } from "react-bootstrap";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Expand } from "../../../../Components/IconComponents";
import { ThemeContext } from "../../../..";

const externalStyle1 = {
  multiselectContainer: {
    minWidth: "7rem",
  },
  searchBox: {
    height: "34px",
  },
  optionContainer: {
    border: "20px",
    color: "#000",
  },
};
const externalStyle2 = {
  multiselectContainer: {
    width: "100%",
  },
  searchBox: {
    height: "34px",
    width: "18rem",
    color: "#fff",
    overflow: "auto",
  },
  optionContainer: {
    border: "20px",
    color: "#000",
  },
};

const DMSDashboard = () => {
  const blockref = useRef();
  let distPopulated = null,
    facilityCodeIdMap = {};
  const [daterange, setDaterange] = useState("MONTH");
  const { t } = useTranslation();
  const [block, setBlock] = useState();
  const [incident, setIncident] = useState({ name: "Incident 1", id: 1 });
  const [options, setOptions] = useState([
    { name: "Incident 1", id: 1 },
    { name: "Incident 2", id: 2 },
  ]);
  const [fromDate, setFromDate] = useState(() => {
  // Set to January 1st, 2026 instead of yesterday
  return new Date(2026, 0, 1); // January 1st, 2026
});

  const [toDate, setToDate] = useState(() => {
  // Set to today's date
  return new Date(); // Today's date
});

  const [selectedDistrcit, setSelectedDistrict] = useState(null);
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [facilityRegisteredInput, setFacilityRegisteredInput] = useState({});
  const [ckData, setCkData] = useState({});
  const [facilityOpenReportData, setFacilityOpenReportData] = useState([]);

  const [fRCampData, setFRCampData] = useState({});
  const [fRCenter, setFRCenterData] = useState({});
  const [aSData, setASData] = useState([]);

  const [incidents, setIncidents] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockoptions, setBlockoptions] = useState([]);
  const [frCampEntityData, setFrCampEntityData] = useState([]);
  const [frCenterEntityData, setFrCenterEntityData] = useState([]);
  const [inidentname, setInidentname] = useState("Flood at Darbhanga");
  const [incidenttime, setIncidenttime] = useState("12-MAR-2024 03:03:00 PM");
  const [regionId, setRegionId] = useState([]);
  const [healthCampData, setHealthCampData] = useState({});
  const [communityKitchenData, setCommunityKitchenData] = useState({});
  const [floodReliefCampData, setFloodReliefCampData] = useState({});
  const [animalShelterData, setAnimalShelterData] = useState({});
  const [facilityRegisteredData, setFacilityRegisteredData] = useState({});
  const [communityKitchenMembersData, setCommunityKitchenMembersData] =
    useState({});
  const [regionIdList, setRegionIdList] = useState([]);
  const [districtId, setDistrictId] = useState(null);
  const [allBlockIds, setAllBlockIds] = useState([]);
  const [distInput, setDistInput] = useState("ALL");
  const [loader, setLoader] = useState(false);
  const [openVsClosedData, setOpenVsClosedData] = useState({});
  const [error, setError] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [stateId, setStateId] = useState(null);
  const {theme} = useContext(ThemeContext);

  const handle = useFullScreenHandle();
  

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 4,
      height: 8,
      id: 0,
      component: (
        <FacilityTypeView
          dataval={communityKitchenData}
          range={daterange}
          title="Community Kitchen"
          config={commmunityKitchen}
        />
      ),
    },
    {
      x: 4,
      y: 0,
      width: 4,
      height: 8,
      id: 1,
      component: (
        <FacilityTypeView
          dataval={floodReliefCampData}
          range={daterange}
          type="floodrelifcamp"
          selincident={incident}
          selblock={block}
          title="Flood Relief Camp"
          config={commmunityKitchen}
        />
      ),
    },
    {
      x: 8,
      y: 0,
      width: 4,
      height: 8,
      id: 6,
      component: (
        <FacilityTypeView
          dataval={healthCampData}
          range={daterange}
          type="floodrelifcamp"
          selincident={incident}
          selblock={block}
          title="Health Camp"
          config={healthCamp}
        />
      ),
    },
    {
      x: 0,
      y: 8,
      width: 3,
      height: 9,
      id: 7,
      component: (
        <CommunityKitchenTrendView dataval={communityKitchenMembersData} />
      ),
    },
    {
      x: 3,
      y: 8,
      width: 3,
      height: 9,
      id: 8,
      component: <AnimalCenterTrendView dataval={animalShelterData} />,
    },
    {
      x: 6,
      y: 8,
      width: 3,
      height: 9,
      id: 10,
      component: <FacilityRegistered dataval={facilityRegisteredData} />,
    },
    {
      x: 9,
      y: 8,
      width: 3,
      height: 9,
      id: 11,
      component: <OpenCloseChart dataval={openVsClosedData} />,
    },
  ];
  const girdoptions = {
    staticGrid: true,
    column: 12,
    margin: 8,
    cellHeight: 45,
  };
  const onSelectBlock = function (selectedList, selectedItem) {
    setSelectedBlocks(selectedList);
    setBlock(selectedItem);

    // Update `region_id_list` with selected block IDs or empty array if no blocks selected
    const regionIds =
      selectedList.length > 0
        ? selectedList.map((block) => block.id)
        : [districtId];
    setAllBlockIds(regionIds);
  };

  const onSelectDistrict = function (selectedList, selectedItem) {
    setSelectedDistrict([selectedItem]); // Update the selected district

    if (selectedItem.id === "all") {
      blockref.current.resetSelectedValues(); // Clear selected blocks in the UI
      setDistInput("ALL"); // Set dist_input to "ALL"
    } else {
      blockref.current.resetSelectedValues(); // Clear previously selected blocks
      getBlockListByDistId(selectedItem.id); // Fetch blocks for the selected district
      setDistInput(selectedItem.name);
      setRegionIdList(allBlockIds); // Set to all block IDs
    }
  };

  const onSelectIncident = function (selectedList, selectedItem) {
    setIncident(selectedItem);
  };
  const gridRef = useRef(null);

  useLayoutEffect(() => {
    setLoader(true);
    getUserProfile();
    getFacilityType();
    getIncidentList();
    getFacilityDashboardData();
    setLoader(false);

    var grid = GridStack.init(girdoptions);
    gridRef.current = grid;
  }, []);

  // Handle sidebar expand/collapse - re-layout grid when parent width changes
  useEffect(() => {
    const dashboardEl = document.querySelector('.dms-dashboard');
    if (!dashboardEl) return;

    const resizeObserver = new ResizeObserver(() => {
      if (gridRef.current) {
        // Force GridStack to recalculate column widths
        gridRef.current.onParentResize();
      }
    });

    resizeObserver.observe(dashboardEl);

    // Also listen for window resize
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.onParentResize();
      }
    };
    window.addEventListener('resize', handleResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Remove getDistrictList() from useLayoutEffect and add this useEffect:
useEffect(() => {
  if (!stateId) return;
  getDistrictList();
}, [stateId]);

  const getUserProfile = async () => {
  try {
    const profile = await getData(getThemeURL);
    if (profile && profile.length > 0) {
      setStateId(profile[0].state_id);
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
  }
};


  const getDistrictList = async () => {
    try {
      const distList = await postDataWithBody(getChildRegionsById, [String(stateId)], {});
      const allOption = { id: "all", name: "All" };
      const updatedDistList = [allOption, ...distList];
      setDistrictList(updatedDistList);
      setSelectedDistrict([updatedDistList[0]]);
      distPopulated = updatedDistList[0].id;
      await getBlockListByDistId(updatedDistList[0].id);
      refreshDashBoards();
    } catch (error) {
      console.error("Error fetching district list:", error);
    }
  };

  const getRegionIdList = async () => {
    let regionIds = [];
    distPopulated =
      distPopulated == null ? selectedDistrcit[0].id : distPopulated;
    if (selectedBlocks.length == 0) {
      if (distPopulated !== "all") {
        var rgnList = await postDataWithBody(
          getChildRegionsById,
          [distPopulated],
          {}
        );
        rgnList?.forEach(function (region) {
          regionIds.push(region.id);
        });
      }
    } else {
      selectedBlocks.forEach(function (node, index) {
        regionIds.push(node.id);
      });
    }
    setRegionId(regionIds);
    return regionIds;
  };
  const refreshDashBoards = async () => {
    setLoader(true);
    await getFacilityType();
    let intervalObj = { TODAY: 0, WEEK: 1, MONTH: 2 };
    let inputObj = {};
    inputObj["interval_type"] = intervalObj[daterange];
    inputObj["end_date"] = new Date().toISOString().slice(0, 10);
    if (fromDate && toDate) {
      inputObj["start_date"] = moment(fromDate).format("YYYY-MM-DD");
      inputObj["end_date"] = moment(toDate).format("YYYY-MM-DD");
    }
    inputObj["region_id"] = await getRegionIdList();
    Promise.all([
      getFacilityType(),
      populateCommunityKitchenInfo(inputObj),
      populateFRCampInfo(inputObj),
      populateFRCenterInfo(inputObj),
      populateFacilitiesRegistered(inputObj),
      populateFacilitiesopenReport(inputObj),
      populateASReport(inputObj),
      populateFlCenterEntityReport(inputObj),
      getFacilityDashboardData(),
    ])
      .catch((error) => {
        console.error("Error refreshing dashboards:", error);
      })
      .finally(() => {
        setLoader(false); // Stop the loader
      });
  };
  const populateFacilitiesRegistered = (inputObj) => {
    setFacilityRegisteredInput(inputObj);
  };
  const populateASReport = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["ANML_SHLTR"];
    const asData = await postDataWithBody(getASStats, inputObj, {});
    setASData(asData);
  };
  const populateFlCampEntityReport = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["FLD_RLF_CMP"];
    const frcmpEntity = await postDataWithBody(
      getFloodEntityStats,
      inputObj,
      {}
    );
    setFrCampEntityData(frcmpEntity[0]);
  };
  const populateFlCenterEntityReport = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["FLD_RLF_CNTR"];
    const frcenterEntity = await postDataWithBody(
      getFloodEntityStats,
      inputObj,
      {}
    );
    setFrCenterEntityData(frcenterEntity[0]);
  };
  const populateCommunityKitchenInfo = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["COMM_KTCHN"];
    const ckFacilityData = await postDataWithBody(
      getFacilityReport,
      inputObj,
      {}
    );

    setCkData(ckFacilityData[0]);
  };
  const populateFacilitiesopenReport = async (inputObj) => {
    const facilityOpenReport = await postDataWithBody(
      getFacilityOpenReport,
      inputObj,
      {}
    );
    setFacilityOpenReportData(facilityOpenReport);
  };
  const populateFRCampInfo = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["FLD_RLF_CMP"];
    const ckFacilityData = await postDataWithBody(
      getFacilityReport,
      inputObj,
      {}
    );

    setFRCampData(ckFacilityData[0]);
  };

  const populateFRCenterInfo = async (inputObj) => {
    inputObj["facility_type_id"] = facilityCodeIdMap["FLD_RLF_CNTR"];
    const ckFacilityData = await postDataWithBody(
      getFacilityReport,
      inputObj,
      {}
    );
    setFRCenterData(ckFacilityData[0]);
  };
  const getBlockListByDistId = async (distId) => {
    try {
      const blockList = await postDataWithBody(
        getChildRegionsById,
        [distId],
        {}
      );
      setBlockoptions(blockList);
      const allIds = blockList.map((block) => block.id);
      setAllBlockIds(allIds);
    } catch (error) {
      console.error("Error fetching block list:", error);
    }
  };

  const transformArrayToObject = (dataArray) => {
    return dataArray.reduce((acc, item) => {
      acc[item.attribute] = item.total_meals;
      return acc;
    }, {});
  };

  const transformArrayToObjectForMealType = (dataArray) => {
    return dataArray.reduce((acc, item) => {
      acc[item.meal_type] = item.total_meals;
      return acc;
    }, {});
  };

  const transformArrayToObjectForName = (dataArray) => {
    return dataArray.reduce((acc, item) => {
      acc[item.name] = item.total_meals;
      return acc;
    }, {});
  };

  const transformArrayToObjectForFR = (dataArray) => {
    return dataArray.reduce((acc, item) => {
      if (item.facility_type) {
        const types = item.facility_type.split(",").map((type) => type.trim());
        types.forEach((type) => {
          acc[type] = (acc[type] || 0) + 1;
        });
      }
      return acc;
    }, {});
  };

  const transformOpenCloseData = (data) => {
    return {
      community_kitchen: {
        open: data.community_kitchen_open_close[0].open,
        closed: data.community_kitchen_open_close[0].closed,
      },
      flood_relief: {
        open: data.flood_relief_open_close[0].open,
        closed: data.flood_relief_open_close[0].closed,
      },
      animal_shelter: {
        open: data.animal_shelter_open_close[0].open,
        closed: data.animal_shelter_open_close[0].closed,
      },
    };
  };

  const getFacilityDashboardData = async () => {
    try {
      const facilityDashboardDataReq = await postDataWithBody(
        facilityDashboardData,
        {
          region_id_list: distInput === "ALL" ? [] : allBlockIds,
          from_date: moment(fromDate).format("YYYY-MM-DD"),
          to_date: moment(toDate).format("YYYY-MM-DD"),
          dist_input: distInput === "ALL" ? distInput : "",
        },
        {}
      );
      const inputData = {
        community_kitchen_open_close:
          facilityDashboardDataReq.community_kitchen_open_close,
        flood_relief_open_close:
          facilityDashboardDataReq.flood_relief_open_close,
        animal_shelter_open_close:
          facilityDashboardDataReq.animal_shelter_open_close,
      };

      const healthCampDataObj = transformArrayToObject(
        facilityDashboardDataReq.health_camp
      );
      const communityKitchenDataObj = transformArrayToObjectForMealType(
        facilityDashboardDataReq.community_kitchen
      );
      const floodReliefcampDataObj = transformArrayToObjectForMealType(
        facilityDashboardDataReq.flood_relief
      );
      const animalShelterDataObj = transformArrayToObjectForMealType(
        facilityDashboardDataReq.animal_shelter
      );
      const facilityRegisteredDataObj = transformArrayToObjectForFR(
        facilityDashboardDataReq.facility_registered
      );
      const communityKitchenMembersDataObj = transformArrayToObjectForMealType(
        facilityDashboardDataReq.community_kitchen_members
      );
      const openVsClosedDataObj = transformOpenCloseData(inputData);
      setHealthCampData(healthCampDataObj);
      setCommunityKitchenData(communityKitchenDataObj);
      setFloodReliefCampData(floodReliefcampDataObj);
      setAnimalShelterData(animalShelterDataObj);
      setFacilityRegisteredData(facilityRegisteredDataObj);
      setCommunityKitchenMembersData(communityKitchenMembersDataObj);
      setOpenVsClosedData(openVsClosedDataObj);
    } catch (error) {
      console.error("Error fetching district list:", error);
    }
  };

  const getIncidentList = async () => {
    var incidentList = await postDataWithBodyFrGIS(getAllincidents, "", {});
    let inputincs = [];
    let name = "";
    if (incidentList && incidentList.data && incidentList.data[0]) {
      let incidentdata = incidentList.data[0];
      setInidentname(incidentdata["name"]);
      setIncidenttime(incidentdata["created_on"]);
    } else {
    }
  };
  const getFacilityType = async () => {
    const userProfile = await getData(getThemeURL);
          const state_id = userProfile[0]?.state_id;
    let res = await postDataWithBody(`${getTaskConfigsURL}/${state_id}`, ["FCLTY_TYP"], {});
    let fm = {};
    res.forEach(function (node, elem) {
      fm[node.code] = node.id;
    });

    facilityCodeIdMap = fm;
  };

  const handleFromDateChange = (date) => {
    if (toDate && date > toDate) {
      setError(true);
      setFromDate(date);
    } else {
      setError(false);
      setFromDate(date);
    }
  };

  const ReadOnlyDateInput = React.forwardRef((props, ref) => (
  <input {...props} ref={ref} onKeyDown={e => e.preventDefault()} readOnly />
));

  const handleToDateChange = (date) => {
    if (fromDate && date < fromDate) {
      setError(true);
      setToDate(date);
    } else {
      setError(false);
      setToDate(date);
    }
  };

  const toggleFullscreen = () => {
    if (isFullscreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullscreen(!isFullscreen);
  };

  useEffect(() => {
    if (fromDate && toDate && fromDate > toDate) {
      setError("Select proper From Date and To Date");
    } else {
      setError(null);
    }
  }, [fromDate, toDate]);
  console.log(selectedDistrcit, "1");
  console.log(blockoptions, "2");
  console.log(allBlockIds, "3");
  console.log(facilityRegisteredData, "facilityRegisteredData");

  return (
    <FullScreen handle={handle}>
      <div
        className={
          isFullscreen
            ? "dms-dashboard fullscreen"
            : "dms-dashboard"
        }
        style={{
          height: isFullscreen ? "100vh" : "auto",
          overflow: isFullscreen ? "auto" : "initial",
          padding: "10px",
        }}
      >
        <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        />
        <div className="dms-toprow">
          <div className="dms-title" style={{ alignItems: "center" }}>
            <div style={{
              width: "34px",
              height: "34px",
              borderRadius: "10px",
              background: "rgba(255,255,255,.14)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              flexShrink: 0,
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 21V7L12 2L21 7V21H15V13H9V21H3Z" fill="white" opacity="0.3"/>
                <path d="M12 2L3 7V21H9V13H15V21H21V7L12 2ZM12 4.26L19 8.14V19H17V11H7V19H5V8.14L12 4.26Z" fill="white"/>
                <rect x="8" y="8" width="2" height="2" rx="0.5" fill="white"/>
                <rect x="11" y="8" width="2" height="2" rx="0.5" fill="white"/>
                <rect x="14" y="8" width="2" height="2" rx="0.5" fill="white"/>
                <rect x="11" y="14" width="2" height="2" rx="0.5" fill="white"/>
              </svg>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1.15 }}>
              <span style={{ fontSize: "1rem", fontWeight: 800, letterSpacing: "0.5px" }}>Facility</span>
              <span style={{ fontSize: "0.7rem", fontWeight: 800, letterSpacing: "1px" }}>Dashboard</span>
            </div>
          </div>
          <div className="d-flex gap-3 align-items-center">
            <div className="dms-daterange">
  <div className="dms-daterange-field">
    <span className="dms-dr-label">FROM</span>
    <ReactDatePicker
      selected={fromDate}
      onChange={handleFromDateChange}
      dateFormat="dd/MM/yyyy"
      isClearable
      minDate={new Date(2026, 0, 1)}
      maxDate={new Date(2026, 11, 31)}
      placeholderText="Select date"
      className="dms-dp-input"
      todayButton="Today"
      customInput={<ReadOnlyDateInput />}
    />
  </div>
  <div className="dms-dr-divider" />
  <div className="dms-daterange-field">
    <span className="dms-dr-label">TO</span>
    <ReactDatePicker
      selected={toDate}
      onChange={handleToDateChange}
      dateFormat="dd/MM/yyyy"
      minDate={fromDate || new Date(2026, 0, 1)}
      maxDate={(() => {
        const today = new Date();
        const dec31 = new Date(2026, 11, 31);
        return today <= dec31 ? today : dec31;
      })()}
      isClearable
      placeholderText="Select date"
      className="dms-dp-input"
      todayButton="Today"
      customInput={<ReadOnlyDateInput />}
    />
  </div>
</div>
            <div className="dms-single-multiselect">
              <Multiselect
                style={externalStyle1}
                options={districtList}
                displayValue="name"
                customArrow={theme === "light" ? false : true}
                placeholder="Select District"
                singleSelect={true}
                closeOnSelect={true}
                onSelect={onSelectDistrict}
                selectedValues={selectedDistrcit}
                customCloseIcon={true}
              />
            </div>
            <div>
              <Multiselect
                style={externalStyle2}
                options={blockoptions}
                displayValue="name"
                isSelectAll={true}
                caseSensitiveSearch={false}
                placeholder={t("allblocks")}
                hidePlaceholder={true}
                singleSelect={false}
                ref={blockref}
                onSelect={onSelectBlock}
                showCheckbox={true}
              />
            </div>
            <div className="dms-apply-btn">
              <LMSButton
                size="btn_sm"
                label={t("flooddisaster.apply")}
                onClick={refreshDashBoards}
                disabled={!!error}
              />
            </div>
            <span className="dms-btn-icon" onClick={toggleFullscreen}>
    <svg viewBox="0 0 18 18" fill="none" width="12" height="12">
      {isFullscreen ? (
        <path d="M2 6H6V2M16 6H12V2M2 12H6V16M16 12H12V16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
      ) : (
        <path d="M2 6V2h4M12 2h4v4M2 12v4h4M16 12v4h-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
      )}
    </svg>
</span>
          </div>
        </div>
        {error && <div className="dms-error-msg">{error}</div>}
        <div className="grid-stack grid-stack-instance-1 mt-1">
          {layoutData.map((gridItem) => (
            <div
              className="grid-stack-item"
              gs-x={gridItem.x}
              gs-y={gridItem.y}
              gs-w={gridItem.width}
              gs-h={gridItem.height}
              key={gridItem.id}
            >
              <div
                className={`grid-stack-item-content ${
                  gridItem?.haveNoBg ? " " : " dms-grid-item"
                } ${
                  gridItem?.haveOverflowVisible
                    ? " apply__overflow--visible"
                    : ""
                }`}
              >
                {gridItem.component}
              </div>
            </div>
          ))}
        </div>
      </div>
    </FullScreen>
  );
};

export default DMSDashboard;